import { RichTextEditorMenuItemConfiguration } from './RichTextEditor/datasets';
import {
  RichTextEditorButton,
  RichTextEditorSelect,
  RichTextEditorTextStyle,
} from './RichTextEditor/types';

export const DEFAULT_RICH_TEXT_MENU_ITEMS: RichTextEditorMenuItemConfiguration[] =
  [
    {
      id: RichTextEditorSelect.TEXT_STYLE,
      orderedOptions: [
        RichTextEditorTextStyle.NORMAL,
        RichTextEditorTextStyle.H2,
      ],
    },
    RichTextEditorButton.BOLD,
    RichTextEditorButton.ITALIC,
    RichTextEditorButton.UNDERLINE,
    RichTextEditorButton.BULLETED_LIST,
    RichTextEditorButton.NUMBERED_LIST,
    RichTextEditorButton.ALIGN_LEFT,
    RichTextEditorButton.ALIGN_CENTER,
    RichTextEditorButton.ALIGN_RIGHT,
    RichTextEditorButton.SET_LINK,
    RichTextEditorButton.UNSET_LINK,
  ];
